<template>
  <div ref="container">

    <a-modal :title="title" :width="600" :visible="visible" :getContainer="() => $refs.container"
      :maskStyle="{ 'top': '93px', 'left': '154px' }" :wrapClassName="wrapClassNameInfo()" :mask="isDesktop()"
      :maskClosable="false" @ok="handleOk" @cancel="handleCancel" cancelText="关闭" style="top:5%;height: 30%;">

      <a-form-model ref="form" :rules="rules" :model="formState" name="basic" :label-col="{ span: 5 }"
        :wrapper-col="{ span: 19 }" autocomplete="off" @finish="onFinish" @finishFailed="onFinishFailed">
        <!-- <a-form-model-item label="防窜货监管" name="username" :rules="[{ required: true, message: 'Please input your username!' }]">
          <a-radio-group v-model:value="value" name="radioGroup">
            <a-radio v-for="it in list" :value="it.value">{{it.name}}</a-radio>
          </a-radio-group>
        </a-form-model-item> -->
        <!-- <a-form-model-item label="防窜货监管级别" name="level" prop="value1">
            <a-radio-group v-model="formState.value1" @change="changegroup">
              <a-radio v-for="it in list1" :value="it.value">{{it.name}}</a-radio>
            </a-radio-group>
          </a-form-model-item> -->
        <a-form-model-item label="选择主营区域" name="address" prop="address">
          <!-- <a-radio-group v-model:value="value2" name="radioGroup" @change="changeaddress">
              <a-radio value="3">全国</a-radio>
              <br>
              <br> -->
          <!-- <a-radio value="0"> -->
          <span v-for="(it, index) in Addlist">
            <a-select v-model:value="it.provinceId" placeholder="请选择省份" style="width: 130px" :class="{ 'isfirst': index != 0 }"
              @change="province_idChange(it.provinceId, index, false)">
              <a-select-option v-for="(item, index) in it.eareList" :key="index"
                :value="item.id.toString()">{{ item.name }}</a-select-option>
            </a-select>
            <a-select :disabled="isCity" v-model:value="it.cityId" placeholder="请选择城市" style="width: 130px"
              @change="city_idChange(it.cityId, index, false)">
              <a-select-option v-for="(item, index) in it.eareList1" :key="index"
                :value="item.id.toString()">{{ item.name }}</a-select-option>
            </a-select>
            <!-- <a-select :disabled="isArea" v-model:value="it.areaId" placeholder="请选择区/县" style="width: 130px" @change="handleChange">
              <a-select-option v-for="(item,index) in it.eareList2" :key="index" :value="item.id.toString()">{{item.name}}</a-select-option>
            </a-select> -->
            <!-- <img v-if="it.reduce==0" @click="addAddress" class="img" src="../../../assets/images/add.png" alt="">
              <img v-if="it.reduce==1" @click="reduceAddress(index)" class="img img-size" src="../../../assets/images/del.png" alt=""> -->
            <br>
          </span>
          <!-- </a-radio> -->
          <!-- </a-radio-group> -->
          <!-- <span v-if="formState.value1==3">全国</span> -->

          <!-- <span v-for="(it,index) in Addlist">
            <a-select v-model:value="it.provinceId" placeholder="请选择" style="width: 130px" :class="{'isfirst':index!=0}" @change="province_idChange(it.provinceId,index)">
              <a-select-option v-for="(item,index) in it.eareList" :key="index" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
            <a-select v-model:value="it.cityId" placeholder="请选择" style="width: 130px" @change="city_idChange(it.cityId,index)">
              <a-select-option v-for="(item,index) in it.eareList1" :key="index" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
            <a-select v-model:value="it.areaId" placeholder="请选择" style="width: 130px" @change="handleChange">
              <a-select-option v-for="(item,index) in it.eareList2" :key="index" :value="item.id">{{item.name}}</a-select-option>
            </a-select>
            <img v-if="it.reduce==0" @click="addAddress" class="img" src="../../../assets/images/add.png" alt="">
            <img v-if="it.reduce==1" @click="reduceAddress(index)" class="img" src="../../../assets/images/del.png" alt="">
            <br>
          </span> -->
        </a-form-model-item>
      </a-form-model>

    </a-modal>
  </div>
</template>
<script>
import Vue from 'vue'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { getAction } from '@/api/manage'
import { getaddressData, fchApi, addLocationName } from '@/api/api'
import { disabledAuthFilter } from '@/utils/authFilter'
import { autoJumpNextInput } from '@/utils/util'
import { mixinDevice } from '@/utils/mixin'
export default {
  name: 'UserModal',
  mixins: [mixinDevice],
  components: {},
  data () {
    return {
      id: '',
      isCity: false,
      isArea: false,
      value: '',
      value2: '0',
      title: '添加主营区域',
      visible: false,
      headers: '',
      spinning: false,
      formState: {
        value1: '',
        provinceId: '',
        cityId: '',
        areaId: '',
      },
      Addlist: [
        {
          provinceId: undefined,
          cityId: undefined,
          areaId: undefined,
          reduce: 0,
          eareList: [],
          eareList1: [],
          eareList2: [],
        },
      ],
      locationList: [],
      list: [
        { name: '开启', value: 0 },
        { name: '关闭', value: 1 },
      ],
      list1: [
        { name: '监管到主营区域的省', value: '0' },
        { name: '监管到主营区域的市', value: '1' },
        { name: '监管到主营区域的区', value: '2' },
        { name: '全国', value: '3' },
      ],
      // 省
      provincelist: [],
      // form: this.$form.createForm(this),
      // validatorRules: {
      //   value1: {
      //     rules: [{ required: true, message: '请选择监管级别!' }],
      //   },
      //   address: {
      //     rules: [{ required: true, message: '请选择监管级别!' }],
      //   },
      // },
      rules: {
        value1: [{ required: true, message: '密码不能为空!' }],
        // address: [{ required: true, message: '地址不能为空!' }],
      },
    }
  },
  created () {
    const token = Vue.ls.get(ACCESS_TOKEN)
    this.headers = { 'X-Access-Token': token }
  },
  methods: {
    changeaddress () {
      if (this.value2 == 3) {
        this.resetting()
      }
    },
    changegroup () {
      // if (this.formState.value1 == '0') {
      //   this.isCity = true
      //   this.isArea = true
      //   console.log(this.Addlist, 'this.Addlist')
      //   this.Addlist.forEach((it) => {
      //     it.cityId = ''
      //     it.areaId = ''
      //   })
      // } else if (this.formState.value1 == '1') {
      //   this.isArea = true
      //   this.isCity = false
      //   this.Addlist.forEach((it) => {
      //     it.areaId = ''
      //   })
      // } else if (this.formState.value1 == '2') {
      //   this.isArea = false
      //   this.isCity = false
      // }
    },
    // async editAddress(record) {
    //   await this.getAddress()
    //   this.Addlist[0].eareList.forEach((it, idx) => {
    //     if (it.id == record.provinceId.split(',')[0]) {
    //       this.Addlist[0].provinceId = it.id
    //       this.province_idChange(it.id, idx)
    //       console.log(it, 'it')
    //       it.children.forEach((item) => {
    //         if (item.id == record.cityId.split(',')[0]) {
    //           this.Addlist[0].cityId = it.id
    //         }
    //       })
    //     }
    //   })
    //   console.log(this.Addlist, 'this.Addlist')
    // },
    async getAddress () {
      const res = await getaddressData()
      console.log(res, 'res')
      if (res.code == 200) {
        this.provincelist = res.data[0].children
        this // this.eareList = res.data[0].children
        this.Addlist.forEach((it) => {
          it.eareList = res.data[0].children
        })
      } else {
        this.$message.warning(res.data)
      }
    },
    // 选择省
    province_idChange (provinceId, index, isChange) {
      console.log(provinceId, index, 'id,索引______')
      // 清空市/区
      if (!isChange) {
        this.clearcity(index)
      }
      console.log(provinceId, '省id')
      let filterList = []
      filterList = this.provincelist.filter((it) => {
        return it.id == provinceId
      })
      this.provincelist.forEach((it) => {
        let ischildren = false
        if (it.id == provinceId && it.children != null) {
          it.children.forEach((item) => {
            if (item.children == null) {
              ischildren = false
            } else {
              ischildren = true
            }
          })
          if (it.children && ischildren) {
            // eareList1.value = it.children
            this.searchcity(index, it.children)
          } else {
            filterList.forEach((item) => {
              // eareList1.value.push(item)
              this.searchzxs(index, item)
            })
          }
        } else if (it.id == provinceId && it.children == null) {
          filterList.forEach((item) => {
            // eareList1.value.push(item)
            this.searchzxs(index, item)
          })
        }
      })
    },
    // 清除市/区
    clearcity (index) {
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          item.cityId = undefined
          item.areaId = undefined
          item.eareList1 = []
          item.eareList2 = []
        }
      })
    },
    // 选择市的时候清除县
    clearareaId (index) {
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          item.areaId = undefined
          item.eareList2 = []
        }
      })
    },
    // 选择市
    // 选择省的时候有children
    searchcity (index, children) {
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          item.eareList1 = children
        }
      })
    },
    // 选择省的时候没有children
    searchzxs (index, it) {
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          item.eareList1.push(it)
        }
      })
    },
    city_idChange (cityId, index, isChange) {
      if (!isChange) {
        this.clearareaId(index)
      }
      let filterList = []
      let citylist = []
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          console.log(item, 'item')
          citylist = item.eareList1
          filterList = item.eareList1.filter((ij) => {
            return ij.id == cityId
          })
        }
        console.log(filterList, 'filterList')
      })
      citylist.forEach((it) => {
        if (it.id == cityId) {
          if (it.children != null) {
            // eareList2.value = it.children
            this.searchareaId(index, it.children)
          } else {
            filterList.forEach((ij) => {
              // eareList2.value.push(ij)
              this.searchlq(index, ij)
            })
          }
        }
      })
    },
    // 选择市的时候有children
    searchareaId (index, value) {
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          console.log(value, 'value')
          item.eareList2 = value
        }
      })
    },
    // 选择市的时候没有children
    searchlq (index, ij) {
      this.Addlist.forEach((item, idx) => {
        if (idx == index) {
          item.eareList2.push(ij)
        }
      })
    },
    // 选择区/县
    handleChange () { },

    onFinish () { },
    onFinishFailed () { },
    addAddress () {
      this.Addlist.push({
        provinceId: undefined,
        cityId: undefined,
        areaId: undefined,
        reduce: 1,
        eareList: this.provincelist,
        eareList1: [],
        eareList2: [],
      })
    },
    reduceAddress (index) {
      console.log(index, '索引')
      this.Addlist.splice(index, 1)
    },
    add (record) {
      this.edit(record)
    },
    async edit (record) {
      console.log(record, 'record1')
      // this.form.resetFields()
      this.visible = true
      if (record.locationName) {
        this.locationList = record.locationName.split(',')
      } else {
        this.locationList = []
      }
      console.log(this.locationList, 'this.locationList')
      this.id = record.id
      await this.getAddress()
      console.log(this.Addlist, ' this.Addlist')
      // if (record.provinceId) {
      //   this.editAddress(record)
      // }
      // this.resetting()
      // this.$refs['form'].resetFields()
      console.log(record.levelRegulation, '绑定值')
    },
    // 重置地址数组
    resetting () {
      this.Addlist = [
        {
          provinceId: undefined,
          cityId: undefined,
          areaId: undefined,
          reduce: 0,
          eareList: [],
          eareList1: [],
          eareList2: [],
        },
      ]
    },
    close () {
      this.$emit('close')
      this.visible = false
      this.disableSubmit = false
      this.resetting()
    },
    async handleOk () {
      for (let i = 0; i < this.Addlist.length; i++) {
        if (this.Addlist[i].provinceId == undefined) {
          return this.$message.warning('请选择主营区域!')
        }
      }

      this.Addlist.forEach((it) => {
        // delete it['eareList']
        // delete it['eareList1']
        // delete it['eareList2']
        delete it['reduce']
        // delete it['provinceId']
        // delete it['cityId']
      })
      console.log(this.Addlist, '地址数组')
      let provincelist = ''
      let citylist = ''
      let arealist = ''
      this.Addlist[0].eareList.forEach((it) => {
        if (this.Addlist[0].provinceId == it.id) {
          provincelist = it.name
        }
      })
      this.Addlist[0].eareList1.forEach((it) => {
        if (this.Addlist[0].cityId == it.id) {
          citylist = it.name
        }
      })
      this.Addlist[0].eareList2.forEach((it) => {
        if (this.Addlist[0].areaId == it.id) {
          arealist = it.name
        }
      })
      let loctionName = provincelist == citylist ? citylist + arealist : provincelist + citylist + arealist
      console.log(loctionName, 'loctionName')
      for (let i = 0; i < this.locationList.length; i++) {
        console.log(this.locationList[i], 'this.locationList[i]')
        if (loctionName == this.locationList[i]) {
          return this.$message.warning('添加失败！已存在相同的主营区域')
        }
      }
      console.log(provincelist.toString(), 'provincelist')
      console.log(citylist.toString(), 'citylist')
      console.log(arealist.toString(), 'arealist')
      let params = {
        type: '经销商',
        id: this.id,
        // provinceId: provincelist.toString(),
        // cityId: citylist.toString(),
        // areaId: arealist.toString(),
        // levelRegulation: '',
        isDeleteLocationName: '0',
        locationName: provincelist == citylist ? citylist + arealist : provincelist + citylist + arealist,
      }
      const res = await addLocationName(params)
      console.log(res, 'res')
      if (res.code == 200) {
        this.close()
        provincelist = []
        citylist = []
        arealist = []
        this.$emit('ok')
      } else {
        this.$message.error(res.data)
      }
    },
    handleCancel () {
      this.close()
    },
  },
}
</script>

<style scoped>
.img {
  margin-bottom: 5px;

  margin-left: 10px;
  width: 25px;
  height: 25px;
}

.img-size {
  width: 23px;
  height: 23px;
}

.box {
  display: inline;
  width: 100%;
  display: flex;
  align-content: center;
}

/* .isfirst {
  margin-left: 25px;
  margin-top: 5px;
} */</style>